// extracted by mini-css-extract-plugin
module.exports = {"action":"Notification_action__svEGe","root":"Notification_root__9O1i5","row":"Notification_row__MnnaZ","title":"Notification_title__6XLtf","message":"Notification_message__PG6tQ"};